import { createFileRoute } from '@tanstack/react-router'
import { FnsListPage } from '@/features/forms-and-surveys/pages'

export const Route = createFileRoute('/_authenticated/forms/')({
  component: FnsListPage,
})
